export const environment = {
  production: true,
  URL_API: 'https://beta.api.insuadvisor.com/api'
};
